import{registerElementSafely as n}from"@cds/core/internal";import{CdsButtonInline as t,CdsInlineButton as i}from"./button-inline.element.js";n("cds-button-inline",t),n("cds-inline-button",i);
